<template>
    <!--main wrapper-->
    <div class="serp-wrapper">
        <!-- Bookmark Popup  -->
        <first-run :which="whichPop" :onClose="onCloseHelp" :onNext="onNextPop" :firstRunQuery="query" :pEngine="productEngine" />
        <!--header wrapper-->
        <div class="header-wrapper">
            <!--nav-->
            <div id="serp-nav">
                <div id="job-btn" class="serp-nav-item" :class="{active:productSearch}" @click="toProductSearch()">{{branding.SearchLabel}}</div>
                <div id="web-btn" class="serp-nav-item" :class="{active:!this.productSearch}" @click="toWebSearch()">Web Search</div>
            </div>
            <!--End of nav-->
            <!--header-->
            <div class="serp-header">
                <div class="serp-logo"><img :src="branding.Logo"></div>
                <div class="thisSearch" v-show="productSearch">
                    <div class="search pad-right">
                        <auto-complete-input v-model='query' ref="queryInput" :placeholder="branding.AutocompletePlaceholder"
                        @selected="onSugSelected()"
                        @return="onSugSelected()"/>
                        <div class="s-icon">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                        <div class="error" v-if="queryError">This field is required, please enter</div>
                    </div>
                    <button id="btn-search" @click="onSugSelected()">{{branding.SearchLabel}}</button>
                </div>
                <div class="webSearch" v-show="!productSearch">
                    <div class="search web">
                        <input ref="webSearch" id="" placeholder="Search the web" v-model="wQuery" @keydown.enter="startWebSearch()"/>
                        <div class="s-icon"><i class="fa fa-globe" aria-hidden="true"></i></div>
                        <div class="error" v-if="queryError">This field is required, please enter</div>
                    </div>
                    <button id="btn-search" @click="startWebSearch()">Web Search</button>
                </div>
            </div>
            <!--End of Header-->
        </div>
        <!--End of header wrapper-->
        <!--serp results-->
        <div class="bodyWrapper">
            <div class="serp-results">
                <!--Left col-->
                <div class="serp-results-left">
                    <!-----First Run Add on------>
                    
                    <intro-box v-show="!hasSearchResults"/>
                    
                    <!-----End of First Run Add on------>
                    <div class="serp-stats" v-show="hasSearchResults">
                        Found {{totalRecords}} {{branding.ProductType}} for
                        <span class="kw"> {{searchTerm}}</span> <span v-if="filterTag" class="filter">{{filterTag}}</span>
                    </div>
                    <!--NoResults-->
                    <div class="serp-noresults" v-show="!hasSearchResults && searchTerm!='' && searchCompleted">
                        <h3>The search <span class="kw">{{searchTerm}}</span> did not match any {{branding.ProductType}}. Try the suggestions below or type a new query above.</h3>
                        <ul>
                            <li>Check your spelling.</li>
                            <li>Try more general keywords</li>
                            <li>Replace abbreviations with the entire word</li>
                        </ul>
                    <br/>
                        <p v-for="{name, url} in altSearchUrls">
                            <a class="other-res" :href="url" :title="name" target="_blank">{{name}}</a>
                        </p>
                    </div>
                    <!-- End of NoResults-->

                    <div v-show="hasSearchResults">
                        <!--results-->
                        <div class="srl has-image" id="searchResults" v-for="(result, index) in filteredSearchResults" :key="index">
                            <a :href="result.url" target="_blank">
                                <div class="srl-container">
                                    <div v-if="result.resultImage && result.resultImage!=''"  class="srl-img"><img :src="result.resultImage"></div>
                                    <div v-else class="srl-img"> <img :src="branding.PlaceholderImg"></div>
                                    <div class="srl-info">
                                        <h3 class="srl-title"><a :href="result.url" target="_blank">{{result.title}}</a></h3>
                                        <div class="srl-link">{{result.domain}}</div>
                                        <div v-show="result.description" class="srl-description">{{result.description}}</div>
                                    
                                    </div>
                                </div>
                            </a>
                            
                        </div>
                        <div class="is-end-container">
                        </div>
                        <!--end of results-->
                    </div>
                    <!--Browse Panel-->
                    <!--End of left col-->
                </div>
                <!--Right col -->
                <div class="rightCol">
                    <div class="rightColInner">
                        <!--End of filter-->
                        <!--Search History-->
                        <div class="module-right side-list history">
                            <h2><i class="fa fa-history" aria-hidden="true"></i>Recent searches</h2>
                            <div class="list" v-for="recent in recentSearches" @click="doRecentSearch(recent)">{{recent}}</div>
                        </div>
                        <div class="to-top-btn">
                            <button id="top-btn" v-if="isNotTop" @click="goToTop()">  <i aria-hidden="true" class="fa fa-arrow-up"></i></button>
                        </div>
                        <!--end of search history-->
                    </div>
                </div>
                <!--End of Right col-->
            </div>
        </div>
        <!--End of resultes-->
        <!--footer-->
        <footer>
            <div class="serp-footer">
                <div class="logoFooter"><img :src="branding.Logo"><span><span id="brandDetails"><i class="fa fa-copyright" aria-hidden="true"></i> {{branding.Trademark}}</span> </span></div>
                <ul>
                    <li><a :href="`https://${branding.RootDomain}/terms-of-service/`">Terms of Service </a></li>
                    <li><a :href="`https://${branding.RootDomain}/privacy-policy/`">Privacy</a></li>
                    <li><a :href="`https://${branding.RootDomain}/contact-us/`">Contact Us</a></li>
                </ul>
            </div>
        </footer>
        <!--end of footer-->
    </div>
    <!-- End of main wrapper -->
</template>

<script>
    "use strict"
    import bp from "babel-polyfill"
    import queryString from 'query-string'
    import 'whatwg-fetch'
    import Humanize from 'humanize-plus'
    import {getSetting, setSetting, getGuid} from "../storage"
    import {WEB_SEARCH_URL, openUrl, SEARCH_API_URL} from '../urls'
    import FirstRun from '../components/FirstRun.vue'
    import AutoCompleteInput from '../components/AutoCompleteInput.vue'
    import IntroBox from '../components/IntroBox.vue'
    import {getBranding, PRODUCT_SEARCH_PROVIDERS, altSearchProvidersUrls} from "../branding"
    import {documentReady} from '../common'

    function validatePop(name){
        switch(name){
            case "intro":
            case "i":
                return "intro"
            case "t":
            case "tutorial":
                return "tutorial"
            case "it":
                return "intro-tutorial"
        }

        return false;
    }

    export default {
        name: 'serp',
        components: {
            'first-run': FirstRun,
            'auto-complete-input': AutoCompleteInput,
            'intro-box': IntroBox
        },
        data() {
            let qs = queryString.parse(window.location.search);
            return {
                openUrl,
                recentSearches: [],
                productSearch: true,
                filterTag: null,
                records: [],
                tags: [],
                categoryTags: [],
                searchCompleted: false,
                query: '' || qs.q,
                wQuery: '',
                queryError: false,
                searchTerm: '',
                guid: qs.guid,
                productEngine: qs.engine || "default",
                whichPop: validatePop(qs.pop) || false,
                branding: getBranding(),
                totalRecords: 0,
                totalPages: 0,
                currentPage: 0,
                perPageNo: 20,
                trigger: 50,
                isFetching: false,
                isNotTop: false,
            }
        },
        mounted() {
            documentReady.then(async() => {
                this.recentSearches = JSON.parse(getSetting("recentSearches")) || [];

                try {
                    this.guid = await getGuid();
                }
                catch (e) {
                    // no extension or guid query paraneter
                }

                if (this.query) {
                    this.doSearch(this.query, true)
                }

                this.$refs.queryInput.focus();
                this.categorySearch();
                this.handleSearchUrl();
                this.scrollCheck();
            })

        },
        created: async function() {
            window.onpopstate = () => {
                this.categorySearch();
                this.handleSearchUrl();
            };
           
        },
        methods: {
            goToTop() {
                window.scrollTo(0,0)
            },
            scrollCheck() {
                window.onscroll = ev => {
                    if(window.scrollY == 0) {
                        this.isNotTop = false;
                    }
                    else {
                        this.isNotTop = true;
                    }

                    if ( window.innerHeight + window.scrollY >= (document.body.offsetHeight + this.trigger)) {
                        // do things here if bottom scroll triggered
                        this.getNextResults()
                    }
                }
            },
            async getNextResults() {
                if(this.currentPage < this.totalPages && !this.isFetching) {
                    this.currentPage += 1
                    const newRecords = await this.makeNextCall()
                    if (newRecords) {
                        this.records = this.records.concat(newRecords)
                    }
                }
                this.isFetching = false;
            },
            async makeNextCall()
            {
                this.isFetching = true;

                const qs = {
                        q: this.query,
                        perPage: this.perPageNo,
                        pageNo: this.currentPage,
                }

                const recordsReq= await fetch(`${SEARCH_API_URL}?${queryString.stringify(qs)}`);
                if (recordsReq.ok) {
                    const recordsRes = await recordsReq.json();
                    return recordsRes.main.records
                }
                this.isFetching=false;
            },
            async startWebSearch() {
                let searchParams = {
                    k: this.wQuery,
                    guid: this.guid
                }
                await openUrl(`${WEB_SEARCH_URL}?${queryString.stringify(searchParams)}`, false)
            },
            validateSearch(withFocus) {
                let {
                    query
                } = this;
                let errs = false;
                if (this.query == "") {
                    errs = errs || {}
                    errs.query = "This field is required, Please enter"
                }
                this.queryError = errs;
                if (withFocus) {
                    if (errs.query) this.$refs.queryInput.focus();
                }
                return errs === false;
            },
            addToBrowserHistory(){
                let qs  = { 
                    ...queryString.parse(window.location.search),
                    q:this.query,
                }
                //Add guid if there is one.
                if(this.guid){ qs.guid=this.guid }
                qs=queryString.stringify(qs);

                let newUrl=this.baseUrl + "?" + qs;
                window.history.pushState({query:this.query},`${this.query}`,newUrl);
                
            },
            async doSearch(term, addToHistory = true) {
                
                window.scrollTo(0,0)
                this.records = [];
                this.currentPage = 0;
                this.searchTerm=term;
                
                if (this.productEngine) {
        
                }
                if (addToHistory) {

                    this.addToBrowserHistory();

                    const maxNumRecentSearches = 10
                    if (this.recentSearches[this.recentSearches.length] != term && term !='')
                    {
                            
                        let queryIndex= this.recentSearches.indexOf(this.query)
                        if (queryIndex != -1)
                        {
                            this.recentSearches.splice(queryIndex, 1)
                        }

                            this.recentSearches.unshift(term);
                    }
                    if (this.recentSearches.length>maxNumRecentSearches)
                    {
                        
                        this.recentSearches.pop()
                    }
                    setSetting("recentSearches",JSON.stringify(this.recentSearches));
                    this.filterTag = null;
                    this.searchCompleted = false;
                    
                    const qs = {
                        q: term,
                        perPage: this.perPageNo,
                        pageNo: this.currentPage,
                    }

                    const recordsReq = await fetch(`${SEARCH_API_URL}?${queryString.stringify(qs)}`);
                    if (recordsReq.ok) {
                        const recordsRes = await recordsReq.json();
                        if (recordsRes && recordsRes.main) {
                            if (term && recordsRes.main.records) {
                                this.records = recordsRes.main.records;
                                this.searchTerm = recordsRes.main.query;
                                this.totalPages = recordsRes.main.numPages;
                                this.totalRecords = recordsRes.main.total;
                                if (recordsRes.main.tags) {
                                    this.tags = recordsRes.main.tags;
                                }
                            }
                            else if (!term && recordsRes.main.tags) {
                                this.categoryTags = recordsRes.main.tags;
                            }
                        }
        
                        this.searchCompleted = true;
                    }
                }
            },
            filterTagResults(ev, tag) {
                ev.preventDefault();
                this.filterTag = tag;
            },
            resetFilterTag() {
                this.filterTag = null;
            },
            toWebSearch() {
                this.productSearch = false;
                this.$nextTick(() => this.$refs.webSearch.focus())
            },
            toProductSearch() {
                this.productSearch = true;
                this.$nextTick(() => {
                    this.$refs.queryInput.focus()
                });
            },
            async handleSearchUrl() {
                let qs = queryString.parse(window.location.search);
                let {q} = qs;
                this.query = q || "";
                if (this.query) {
                    await this.doSearch(this.query, false);
                }
            },
            async categorySearch() {
            },
            onNextPop(tag) {
                this.whichPop = validatePop(tag) || false;
            },
            onCloseHelp() {
                switch (this.whichPop) {
                    case "intro-tutorial":
                    this.whichPop = validatePop("i");
                    return;
                }
                this.whichPop = false
            },
            async doRecentSearch(term) {
                this.query = term;
                await this.doSearch(this.query);
            },
            async onSugSelected() {
                if (!this.validateSearch(true)) return;
                await this.doSearch(this.query);
            },
            microdataFields(data) {
                Object.keys(data).forEach(key => data[key] === '' && delete data[key]);
                return data;
            },
        },
        computed: {
            baseUrl(){
            return window.location.href.split('?')[0];
            },
            isEnd() {
                return this.currentPage >= (this.totalPages-1)
            },
            hasSearchResults() {
                return this.numResults > 0;
            },
            numResults() {
                return this.filteredSearchResults.length;
            },
            filteredSearchResults() {
                if (!this.filterTag) {
                    return this.records;
                }
                else {
                    return this.records.filter(record => record.tags.includes(this.filterTag));
                }
            },
            numTagRecords() {
                if (this.tags) return this.tags;
                var tags = {};
                for (let record of this.records) {
                    for (let tag of record.tags) {
                        const tagTotal = tags[tag] && tags[tag]["total"];
                        tags[tag] = {total: ++tagTotal || 1};
                    }
                }
                return tags;
            },
            altSearchUrls() {
                return altSearchProvidersUrls(this.query);
            },
            
        }
    }
</script>

<style>
    @import './css/serp.css';
</style>



// WEBPACK FOOTER //
// src/serp/Serp.vue